import { render, staticRenderFns } from "./LblPayrollDeduct.vue?vue&type=template&id=8e88d150&scoped=true"
import script from "./LblPayrollDeduct.vue?vue&type=script&lang=js"
export * from "./LblPayrollDeduct.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8e88d150",
  null
  
)

export default component.exports